import React from 'react';

class Footer extends React.Component {
  render() {
    return (
      <footer className="movie-card-footer">
        <h5 className="footer">Desenvolvido por @SavioMoraes 2021</h5>
      </footer>
    );
  }
}

export default Footer;
